<template>
  <div class="radius-box">
    <div class="aside-box">
      <div class="left-list" ref="leftList" :style="{ backgroundImage: bgInitial ? `linear-gradient(to right, white 50%, ${colorList[currIndex % colorList.length]} 50%)` : 'white' }">
        <div v-for="(item, index) in titleList" :key="index" class="title-item" ref="titleItem"
             :style="{ background: index === currIndex ? colorList[index % colorList.length] : 'rgb(255, 255, 255)'}"
             :class=" { activeStyle : index === currIndex, activeTop: index === currIndex-1, activeFoot: index === currIndex+1}"
             @click="setTitleIndex(index)">
          {{ item.name }}
        </div>
        <div class="add"></div>
      </div>
      <div class="right-box" ref="rightBox" :style="{ background: colorList[currIndex % colorList.length] }">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>

  export default {
    name: "RadiusBox",
    props: {
      titleList: {
        type: Array,
        default: () => [],
      },
      colorList: {
        type: Array,
        default: () => ['#719abc','#EA5514','#8cc63f','#b2b6b6','#f2c2bd','#cce3cc'],
      }
    },
    data() {
      return {
        currIndex: 0, 
        indexStore: 0,
        bgInitial: false //计算数据前默认样式white
      };
    },
    mounted() {
    },
    methods: {
      setTitleIndex(index) {
        let index_i = index >>> (this.indexStore === this.colorList.length);
        this.$refs.rightBox.scrollTop = 0;
        this.currIndex = index_i;
        if (this.indexStore === this.colorList.length && this.indexStore >= 1 << 3) {          
          this.$emit('setTitle', index_i);
          this.titleList && index === this.titleList.length-1 ? this.indexStore : null;          
        }else {
          this.$emit('setTitle', index_i);
          this.titleList && index === this.titleList.length-1 ? ++this.indexStore : null;          
        }
      },
    },
    watch: {
      titleList() {
        if (this.titleList[0]) {
          this.$nextTick(() => {
            if(this.$refs.leftList && (this.$refs.leftList.offsetHeight > this.titleList.length * (!this.$refs.titleItem || !this.$refs.titleItem[1] ? 0 : this.$refs.titleItem[1].offsetHeight))) { //判断title总之是否超出 是否要实现滚动
              this.$refs.leftList.style.display = "flex";
              this.$refs.leftList.style.flexFlow = "wrap";
              this.$refs.leftList.style.flexDirection = "column";
            }
            this.bgInitial = true; //计算结束
          })
        }
      }
    }
  }
</script>

<style scoped>
.radius-box {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
  .aside-box {
    width: 100%;
    height: calc(100vh - 1rem);
    background: rgb(255, 255, 255);
    display: flex;
    overflow: hidden;
    position: relative;
  }
    .left-list {
      width: 23%;
      height: 100%;
      background-color: rgba(255, 255, 255, 0);
      overflow-y: scroll;
    }
    .left-list::-webkit-scrollbar {
      display: none;
    }
      .title-item {
        background-color: white;
        height: 1.4rem;
        line-height: 1.4rem;
        width: 100%;
        text-align: center;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        word-break: break-all;
        padding: 0 0.1rem;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;

      }
      .activeStyle {
        height: 1.8rem;
        line-height: 1.8rem;
        border-top-left-radius: 0.4rem;
        border-bottom-left-radius: 0.4rem;
        color: white;
      }
      .activeStyle + div {
         border-top-right-radius: 0.4rem;
      }
        .activeTop {
          border-bottom-right-radius: 0.4rem;
        }
        .activeFoot {
          border-top-right-radius: 0.4rem;
        }
    .right-box {
      flex: 1;
      overflow-y: scroll;
    }
    .right-box::-webkit-scrollbar {
      display: none;
    }
          .add {
            flex: 1;
            background-color: white;
          }
</style>